import { Box, Text, VStack } from "@chakra-ui/react";
import { Form, Formik, FormikConfig } from "formik";
import { FC } from "react";

import { FormControl } from "~/src/components/common/forms/FormControl";
import { FormikConfirmationButtons } from "~/src/components/common/forms/FormikConfirmationButtons";
import { FormikTextareaField } from "~/src/components/common/forms/FormikTextareaField";

import { FormValues, validationSchema } from "./legacyValidationSchema";

export type Props = {
  initialValues: FormValues;
  onCancelClick: () => void;
  onSubmit: FormikConfig<FormValues>["onSubmit"];
};

export const LegacyScriptTagSettingForm: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ initialValues, onCancelClick, onSubmit }) => (
  <Box margin="0 auto" maxWidth="800px">
    <Formik<FormValues>
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount={false}
      validateOnChange={false}
      onSubmit={onSubmit}
    >
      <Form>
        <VStack spacing="24px" alignItems="flex-start">
          <FormControl
            label="JavaScriptタグ"
            help={
              <Text>
                Robeeと一緒に発火させたいjavascriptコードのみを入力してください。
                <br />
                クライアントに紐づくjavascriptコードを設定します
                <br />
                使用例： GTMをrobeeで発火させる　など
              </Text>
            }
          >
            <FormikTextareaField
              mode="fill"
              name="userTag"
              resize="both"
              height="165px"
            />
          </FormControl>
          <FormikConfirmationButtons
            onCancelClick={onCancelClick}
            message={
              "JavaScriptタグはrobeeタグが埋め込まれた全ページで発火するタグになります。本当に保存しても良いですか？"
            }
          />
        </VStack>
      </Form>
    </Formik>
  </Box>
);
